module.exports = __webpack_public_path__ + "img/ref.326ce578.png";